import { useQuery } from '@tanstack/react-query';

import { api } from '../api';

export interface AdminAuditEvent {
  id: string;
  actorId: string;
  actorLabel: string;
  action: string;
  targetType: string;
  targetId: string | null;
  targetLabel: string | null;
  detail: unknown;
  createdAt: string;
}

export function useAdminAudit(opts?: { targetType?: string; limit?: number; offset?: number }) {
  const qs = new URLSearchParams();
  if (opts?.targetType) qs.set('targetType', opts.targetType);
  if (opts?.limit != null) qs.set('limit', String(opts.limit));
  if (opts?.offset != null) qs.set('offset', String(opts.offset));
  const suffix = qs.toString() ? `?${qs}` : '';
  return useQuery({
    queryKey: ['admin-audit', opts ?? {}],
    queryFn: () => api<{ rows: AdminAuditEvent[]; total: number }>(`/admin/audit${suffix}`),
  });
}
